var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSlider = function SvgSlider(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 70 70"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    d: "M19 16c0-8.837 7.163-16 16-16s16 7.163 16 16v38c0 8.837-7.163 16-16 16s-16-7.163-16-16V16Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#666",
    fillRule: "evenodd",
    d: "M15 30H5a5 5 0 0 0 0 10h10V30Zm36 10H19V30h32v10Zm4 0h10a5 5 0 0 0 0-10H55v10Z",
    clipRule: "evenodd"
  })));
};
export default SvgSlider;